import { Formik } from "formik";
import { useEffect, useState } from "react";
import { Alert, Badge, Button, Col, Form, Modal, Spinner, Tab, Tabs, OverlayTrigger, Tooltip, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import Multiselect from "../../../components/MultiselectFormik";
import SegmentVisualizer from "./SegmentVisualizer";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { editNotificationBody, saveNotificationBody } from "../../../redux/moduloNotificaciones/cuerpoNotificacion/actions";
import moment from "moment";
import { MODULES } from "../../../pages/Modulo_Notificaciones/Constants";

const ModalNotification = ({ setShowModal, showModal, notification, edit }) => {
    const [validated, setValidated] = useState(false);
    const dispatch = useDispatch();
    const [companiesGroup, setCompaniesGroup] = useState([]);
    const [showSegmentVisualizer, setShowSegmentVisualizer] = useState(false);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const { module } = useParams()

    //obtener código del módulo
    const moduleData = Object.values(MODULES).find(mod => mod.path === `/conf-notificaciones/monitor/${module}`);

    const filters = { offset: 0, limit: 10, tipo_busqueda2: "modulo", filter2: moduleData?.code }

    const schema = Yup.object().shape({
        titulo: Yup.string().required("El título es requerido"),
        pais: Yup.string().nullable(),
        segmento: Yup.string().required("El segmento es requerido"),
        cuerpo: Yup.string().required("El cuerpo es requerido"),
        tipo_envio: Yup.array().test({
            message: "**Campo requerido",
            test: (val) => {
                return val?.length !== 0;
            },
        }),
        fecha_inicio: Yup.date()
            .when('$edit', (edit, schema) => {
                return edit
                    ? schema.min(new Date(), "La fecha de inicio no puede ser anterior a la fecha actual")
                    : schema;
            })
            .required("La fecha de inicio es requerida"),
        fecha_fin: Yup.date()
            .required("La fecha de fin es requerida")
            .when('fecha_inicio', (fecha_inicio, schema) => {
                return fecha_inicio
                    ? schema.min(fecha_inicio, "La fecha de fin no puede ser anterior a la fecha de inicio")
                    : schema;
            }),
        momento_dia: Yup.string()
            .oneOf(["inicio", "fin"], "Debe seleccionar una opción")
            .required("Debe seleccionar una opción"),

    });

    //////REDUX

    //notificación
    const {
        saveLoading,
        formError
    } = useSelector((store) => store.notificationBody);

    //empresa 
    const compania = useSelector((store) => store.compania.compania);
    const companiaLoader = useSelector((store) => store.compania.loading);

    //países
    const countries = useSelector((store) => store.countryUser.countryUser);

    //tipo de envío
    const {
        loading: loadingNotificationTypes,
        notificationTypes
    } = useSelector((store) => store.notificationsType)

    //variables de notificación
    const {
        loading: loadingVariables,
        notificationVariablesLength,
        notificationVariables,
        notificationVariableError
    } = useSelector((store) => store.notificationVariable);

    //segmentos de notificación
    const {
        loading: notificationSegmentLoading,
        notificationSegmentsLength,
        notificationSegments
    } = useSelector((store) => store.notificationSegment);


    //// OPCIONES SELECTS   
    let empresasOptions = []
    compania.map((item) => {
        empresasOptions = [...empresasOptions, { value: item.id, label: `${item.codigo}/${item.nombre}` }];
    });

    let tiposEnvioOptions = []
    notificationTypes.map((item) => {
        tiposEnvioOptions = [...tiposEnvioOptions, { value: item.id, label: item.descripcion }];
    });

    let segmentosOptions = []
    notificationSegments.map((item) => {
        segmentosOptions = [...segmentosOptions, { id: item.id, label: item.nombre }];
    });

    let countriesOptions = []
    countries?.data.map((item) => {
        countriesOptions = [...countriesOptions, { id: item.nombre, label: `${(item.nombre).toUpperCase()}` }];
    });



    ///// MÉTODOS

    const onSubmit = async (values) => {
        let req = {
            correo: {
                titulo: values.titulo,
                cuerpo: values.cuerpo,
                estado: true,
                modulo: moduleData?.code,
                pais: values.pais ? values.pais : null,
            },
            envio: {
                fecha_inicio: values.fecha_inicio,
                fecha_fin: values.fecha_fin,
                inicio_dia: values.momento_dia == "inicio" ? true : false,
                fin_dia: values.momento_dia == "fin" ? true : false,
                tipo_correo: values.tipo_envio.map((item) => item.value),
                segmento: values.segmento
            }
        }


        if (edit) {            
            dispatch(editNotificationBody(req.correo, req.envio, notification.id, notification.envio_correo[0]?.id, setShowModal, filters));
        } else {
            dispatch(saveNotificationBody(req, setShowModal, filters));
        }

    }

    return (
        <Modal
            show={showModal}
            size="lg"
            onHide={() => {
                setShowModal(false);
            }}
        >
            <Formik
                validationSchema={schema}
                onSubmit={onSubmit}
                initialValues={{
                    titulo: edit ? notification.titulo : "",
                    pais: edit ? notification?.pais : "",
                    cuerpo: edit ? notification.cuerpo : "",
                    tipo_envio: edit ? notification.envio_correo[0].list_tipo_correo.map((item) => { return { value: item.id, label: item.descripcion } }) : [],
                    segmento: edit ? notification.envio_correo[0].segmento : "",
                    fecha_inicio: edit ? notification.envio_correo[0].fecha_inicio : "",
                    fecha_fin: edit ? notification.envio_correo[0].fecha_fin : "",
                    momento_dia: edit ? (notification.envio_correo[0].inicio_dia ? "inicio" : "fin") : "inicio"
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    setFieldTouched,
                    values,
                    touched,
                    errors,
                }) => (
                    <Form onSubmit={handleSubmit} noValidate validated={validated}>
                        <Modal.Header closeButton>
                            <Modal.Title className="text-muted">
                                {edit ? "Editar Notificación" : "Crear Notificación"}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Tabs
                                defaultActiveKey="detalle"
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="detalle" title="Detalles">
                                    {!!formError && (
                                        <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                                            {formError}
                                        </Alert>
                                    )}
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label column sm="12" md="12">
                                            Título
                                        </Form.Label>
                                        <Form.Control
                                            id="titulo"
                                            name="titulo"
                                            isInvalid={touched.titulo && errors.titulo}
                                            isValid={touched.titulo && !errors.titulo}
                                            onBlur={handleBlur("titulo")}
                                            onChange={handleChange}
                                            value={values.titulo}
                                            className="rounded-pill mb-4"
                                            type="text"
                                            placeholder="Título"
                                        ></Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label column sm="12" md="12">
                                            Descripción
                                        </Form.Label>
                                        <div className="mb-2">
                                            {loadingVariables && (
                                                <Spinner animation="border" size="sm" />)
                                            }
                                            {notificationVariableError && (
                                                <Alert variant="danger" className="mt-2">
                                                    {notificationVariableError}
                                                </Alert>
                                            )}
                                            {!loadingVariables && notificationVariablesLength > 0 && (
                                                <div>
                                                    <span className="me-2">Variables disponibles: &nbsp;</span>
                                                    {notificationVariables?.map((variable) => (
                                                        <OverlayTrigger
                                                            container={document.querySelector('.modal')}
                                                            key={variable.id}
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id={`tooltip-${variable.id}`}>
                                                                    {variable.descripcion}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Badge
                                                                variant="secondary"
                                                                className="mr-2"
                                                                style={{ cursor: "pointer", fontSize: "0.8rem" }}
                                                                onClick={() =>
                                                                    setFieldValue("cuerpo", `${values.cuerpo} ${variable.variable} `)
                                                                }
                                                                key={variable.id}
                                                            >
                                                                {variable.variable}
                                                            </Badge>
                                                        </OverlayTrigger>

                                                    ))}
                                                </div>
                                            )}

                                        </div>
                                        <Form.Control
                                            name="cuerpo"
                                            isInvalid={touched.cuerpo && errors.cuerpo}
                                            isValid={touched.cuerpo && !errors.cuerpo}
                                            onBlur={handleBlur("cuerpo")}
                                            onChange={handleChange}
                                            value={values.cuerpo}
                                            as="textarea"
                                            placeholder="Ejemplo: Hola @@empleado, le recordamos que..."
                                            rows={3}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label column sm="12" md="12">
                                            Enviar por:
                                        </Form.Label>

                                        <Multiselect
                                            id="tipo_envio"
                                            name="tipo_envio"
                                            disabled={loadingNotificationTypes}
                                            options={tiposEnvioOptions}
                                            value={values.tipo_envio}
                                            onChange={(selected) => {
                                                setFieldValue(
                                                    "tipo_envio",
                                                    selected.length > 0 ? selected : []
                                                );
                                            }}
                                            isValid={touched.tipo_envio && !errors.tipo_envio}
                                            isInvalid={touched.tipo_envio && errors.tipo_envio}
                                            onBlur={() => handleBlur("tipo_envio")}
                                            onFocus={() => setFieldTouched("tipo_envio", true)}
                                        />
                                        {touched.tipo_envio && errors.tipo_envio && (
                                            // <div>
                                            <small className="mx-2 text-danger">
                                                {errors.tipo_envio}
                                            </small>
                                            // </div>
                                        )}
                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label column sm="12" md="12">
                                            Segmento:
                                        </Form.Label>
                                        <Row className="p-0 m-0">
                                            <Col className="mb-3 p-0" sm={10}>
                                                <Typeahead
                                                    id="segmento"
                                                    name="segmento"
                                                    isInvalid={touched.segmento && errors.segmento}
                                                    isValid={touched.segmento && !errors.segmento}
                                                    onBlur={handleBlur("Factor")}
                                                    placeholder="Seleccione un segmento"
                                                    options={segmentosOptions}
                                                    value={values.segmento}
                                                    onChange={(selected) => {
                                                        setFieldValue(
                                                            "segmento",
                                                            selected.length > 0 ? selected[0].id : "",

                                                        );

                                                    }}
                                                    defaultInputValue={edit ? `${notification.envio_correo?.[0]?.list_segmento?.[0]?.nombre}` : ""}


                                                >

                                                </Typeahead>
                                                {touched.segmento && errors.segmento && (
                                                    <div>
                                                        <small className="mx-2 text-danger">
                                                            {errors.segmento}
                                                        </small>
                                                    </div>
                                                )}
                                            </Col>
                                            <Col className="text-right p-0" sm={2}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-segmento">
                                                            Ver detalles del segmento seleccionado
                                                        </Tooltip>
                                                    }
                                                    container={document.querySelector('.modal')}
                                                >
                                                    <Button
                                                        variant="outline-secondary"
                                                        className="rounded-pill"
                                                        disabled={!values.segmento}
                                                        size="sm"
                                                        onClick={() => {
                                                            const segment = notificationSegments.find(seg => seg.id === values.segmento);
                                                            setSelectedSegment(segment);
                                                            setShowSegmentVisualizer(true);
                                                        }}
                                                    >
                                                        <i className="material-icons">visibility</i>
                                                    </Button>

                                                </OverlayTrigger>
                                            </Col>
                                        </Row>


                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label column sm="12" md="12">
                                            País:
                                        </Form.Label>

                                        <Typeahead
                                            id="pais"
                                            name="pais"
                                            isInvalid={touched.pais && errors.pais}
                                            isValid={touched.pais && !errors.pais}
                                            onBlur={handleBlur("Factor")}
                                            placeholder="Seleccione un pais"
                                            options={countriesOptions}
                                            value={values.pais}
                                            onChange={(selected) => {
                                                setFieldValue(
                                                    "pais",
                                                    selected.length > 0 ? selected[0].id : "",

                                                );

                                            }}
                                            onInputChange={(text, e) => {
                                                if (text === "") {
                                                    setFieldValue("pais", null);
                                                }
                                            }}
                                            defaultInputValue={edit ? notification.pais != null ? `${(notification?.pais).toUpperCase()}` : "" : ""}
                                        >
                                        </Typeahead>
                                        {touched.pais && errors.pais && (
                                            <div>
                                                <small className="mx-2 text-danger">
                                                    {errors.pais}
                                                </small>
                                            </div>
                                        )}
                                    </Form.Group>

                                </Tab>
                                <Tab eventKey="fecha" title="Fechas">
                                    {!!formError && (
                                        <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                                            {formError}
                                        </Alert>
                                    )}
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Fecha de Inicio</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="fecha_inicio"
                                            value={values.fecha_inicio}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.fecha_inicio && errors.fecha_inicio}
                                            isValid={touched.fecha_inicio && !errors.fecha_inicio}
                                            id="fecha_inicio"
                                        />
                                        {errors.fecha_inicio && touched.fecha_inicio && (<div className="text-danger">{errors.fecha_inicio}</div>)}
                                    </Form.Group>

                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Fecha Fin</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="fecha_fin"
                                            value={values.fecha_fin}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.fecha_fin && errors.fecha_fin}
                                            isValid={touched.fecha_fin && !errors.fecha_fin}
                                            id="fecha_fin"
                                        />
                                        {errors.fecha_fin && touched.fecha_fin && (<div className="text-danger">{errors.fecha_fin}</div>)}
                                    </Form.Group>

                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Momento del día para el envío</Form.Label>
                                        <div>
                                            <Form.Check
                                                type="radio"
                                                label="Enviar a inicio del día"
                                                name="momento_dia"
                                                id="inicio_dia"
                                                value="inicio"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                checked={values.momento_dia === "inicio"}
                                                isInvalid={touched.momento_dia && !!errors.momento_dia}
                                            />
                                            <Form.Check
                                                type="radio"
                                                label="Enviar al final del día"
                                                name="momento_dia"
                                                id="fin_dia"
                                                value="fin"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                checked={values.momento_dia === "fin"}
                                                isInvalid={touched.momento_dia && !!errors.momento_dia}
                                            />
                                            {touched.momento_dia && errors.momento_dia && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.momento_dia}
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    </Form.Group>


                                </Tab>

                            </Tabs>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                className="rounded-pill"
                                variant="secondary"
                                onClick={() => setShowModal(false)}
                            >
                                Cerrar
                            </Button>
                            <Button
                                className="rounded-pill"
                                variant="primary"
                                disabled={saveLoading}
                                type="submit"

                            >
                                {" "}
                                {saveLoading && (
                                    <Spinner
                                        className="mr-2"
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                )}
                                Guardar
                            </Button>
                        </Modal.Footer>

                        <SegmentVisualizer
                            segment={selectedSegment}
                            showModal={showSegmentVisualizer}
                            setShowModal={setShowSegmentVisualizer}
                        />
                    </Form>
                )}
            </Formik>
        </Modal >
    )
}

export default ModalNotification;